<template>
  <v-container fluid class="pt-12">
    <v-row justify="center" align="center">
      <v-col cols="12" sm="8" lg="6">
        <v-alert
          v-if="showError && errorOnAuthenticate"
          v-model="showError"
          type="error"
          dense
          dismissible
        >
          {{ errorOnAuthenticate.message }}
        </v-alert>

        <v-card>
          <v-card-title class="text-h4 font-weight-medium"> Log in </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="email"
              type="email"
              :rules="emailRules"
              label="E-mail"
              placeholder=" "
              persistent-placeholder
              outlined
              dense
            />
            <v-text-field
              v-model="password"
              :type="showPass ? 'text' : 'password'"
              :rules="passwordRules"
              label="Password"
              placeholder=" "
              persistent-placeholder
              outlined
              dense
              :append-icon="showPass ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="showPass = !showPass"
            />
            <v-row>
              <v-col cols="12" sm="6" class="pt-0">
                <v-checkbox v-model="remember" label="Remember Me" class="pt-0" dense> </v-checkbox>
              </v-col>
              <v-col cols="12" sm="6" :class="'pt-0 mt-1 text-sm-right text-left'">
                <a :href="portalUrl" target="_blank">Forgot Password?</a>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" class="px-10" @click.stop="login()">Login</v-btn>
            <v-spacer />
            <v-btn color="primary" :to="{ name: 'account-registration' }" text>
              Create Account
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";

// TODO: add mixin methods if needed

export default {
  name: "LoginPage",
  data() {
    return {
      email: "",
      password: "",
      showPass: false,
      remember: false,
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      passwordRules: [(v) => !!v || "Password is required"],
      showError: false,
    };
  },
  computed: {
    ...mapState("auth", ["isAuthenticatePending", "errorOnAuthenticate"]),
    urlQuery() {
      return this.$route.query;
    },
    portalUrl() {
      return process.env.NODE_ENV === "production"
        ? "https://portal.acelerex.com/account/reset-password"
        : "https://portal.staging.acelerex.com/account/reset-password";
    },
  },
  methods: {
    ...mapActions({ authenticate: "auth/authenticate" }),
    async login() {
      let resp;
      try {
        resp = await this.authenticate({
          strategy: "local",
          email: this.email,
          password: this.password,
        });
      } catch (error) {
        console.error(error);
        this.showError = true;
        return;
      }

      if (!resp) {
        return;
      }

      const { redirect } = this.$route.query;

      if (redirect) {
        this.$router.push(redirect);
      } else {
        this.$router.push({ path: "/" });
      }
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
a:hover {
  color: rgb(40, 91, 115);
}
</style>
